import { Controller } from 'stimulus';

export default class extends Controller {

  connect() {
    if (this.element.dataset.reservedPriceMet && this.element.dataset.highestBidIsMine) {
      serviceChargeCalculation(this.element.dataset.highestBidAmount);
    }
  }
}